export enum FailureKind {
  /**
   * Planning a motion failed. Recovery is just acknowledgement from the user.
   */
  PlanningFailure = 'PlanningFailure',

  /**
   * Executing a motion failed. Recovery is just acknowledgement from the user.
   */
  ExecutionFailure = 'ExecutionFailure',

  /**
   * General control system error
   */
  ControlSystemFailure = 'ControlSystemFailure',

  /**
   * The E-Stop button was pressed/triggered
   */
  EStopTriggered = 'EStopTriggered',

  /**
   * Arm power was deliberately cut by the user — the UI "Power Off Arm"
   * action or the public API stop endpoint. Transported as a software
   * E-Stop on the wire, but it is not an emergency: there is no physical
   * E-Stop to release, and recovery is simply re-enabling arm power.
   */
  PoweredOff = 'PoweredOff',

  /**
   * A safety watchdog violation occurred
   */
  SafetyWatchdogViolation = 'SafetyWatchdogViolation',

  /**
   * The gripper encountered some kind of failure
   */
  GripperFailure = 'GripperFailure',

  /**
   * Robot violated the joint limits. Recovery is a recovery path that slowly the arm
   * back into its limits.
   */
  OutOfJointLimitsFailure = 'OutOfJointLimitsFailure',

  /**
   * Robot is in (self) collision detected through kinematics
   */
  CollisionFailure = 'CollisionFailure',

  /**
   * Detected a torque discrepancy greater than collision limit
   */
  TorqueCollisionFailure = 'TorqueCollisionFailure',

  /**
   * Detected a large joint angle deviation greater than threshold caused by a collision
   */
  CollisionDeviationFailure = 'CollisionDeviationFailure',

  /**
   * In boxed position: nothing else is possible until unboxed
   */
  InBoxingPositionFailure = 'InBoxingPositionFailure',

  /**
   * The power board failed it's health check
   */
  PowerBoardCheckFailure = 'PowerBoardCheckFailure',

  /**
   * The motion planner encountered some form of failure, ranging from
   * the routine runner not being able to connect to encountering a
   * runtime error.
   */
  MotionPlannerFailure = 'MotionPlannerFailure',

  /**
   * The motion planner fails to plan because the starting position is in collision
   */
  MotionPlannerFailureStartPositionCollision = 'MotionPlannerFailureStartPositionCollision',

  /**
   * There is currently a triggered IO safeguard rule that prevents
   * the routine from running.
   */
  IOFailure = 'IOFailure',

  /**
   * An invalid routine has been loaded. Recovery will unload the currently loaded routine.
   */
  InvalidRoutineLoadedFailure = 'InvalidRoutineLoadedFailure',

  /**
   * Inference failure. Recovery just acknowledges the problem.
   */
  InferenceFailure = 'InferenceFailure',

  /**
   * Camera failure. Recovery just acknowledges the problem
   */
  CameraFailure = 'CameraFailure',

  /**
   * Failures with a Haas machine. Recovery just acknowledges the problem.
   */
  HaasFailure = 'HaasFailure',

  /**
   * The heartbeat sent from botman to arm-control-bot was lost.
   */
  BotmanHeartbeatLost = 'BotmanHeartbeatLost',

  /**
   * An internal error occurred; primarily programming errors. Not recoverable.
   * If problem persists, user should contact support.
   */
  InternalFailure = 'InternalFailure',

  TorqueLimitExceeded = 'TorqueLimitExceeded',

  /**
   * Any failure occurred while running a step.
   */
  StepPlayFailure = 'StepPlayFailure',

  /**
   * Unbraking failed
   */
  UnbrakeFailure = 'UnbrakeFailure',

  /**
   * Weld step failed
   */
  WeldFailure = 'WeldFailure',

  /**
   * A rotary weld found its positioner out of alignment, so the arc never
   * started. Distinct from WeldFailure: the machine is fine, the workpiece is
   * not in position. Recovery is the operator rotating the part into
   * alignment and restarting the routine.
   */
  WeldPositionerNotAligned = 'WeldPositionerNotAligned',

  /**
   * Failure occurred while running the trigger fault step
   */
  TriggerFaultFailure = 'TriggerFaultFailure',

  /**
   * Communication with the arm-control-bot timed out
   */
  ArmControlBotTimeoutFailure = 'ArmControlBotTimeoutFailure',

  /**
   * 3PE (3-Position Enable) safety stop was triggered during guided mode motion.
   * Recovery requires user to re-hold the guided mode button.
   */
  Pause3PEFailure = 'Pause3PEFailure',
}
